import type { Messages } from '../catalogue.en'

export const estimates: Partial<Messages> = {
  'estimate.send.routingPreferences': 'המסירה מתבצעת בהתאם להעדפות התקשורת של המטופל.',
  'estimate.status.draft': 'טיוטה',
  'estimate.status.issued': 'הונפקה',
  'estimate.source.clinic': 'שירות המרפאה',
  'estimate.source.external': 'הוצאה חיצונית',
  'estimate.template.clinicTreatment': 'טיפול במרפאה',
  'estimate.template.externalMedical': 'שירותים רפואיים חיצוניים',
  'estimate.template.documentsAndLegal': 'מסמכים ושירותים משפטיים',
  'estimate.template.travelAndTransfer': 'נסיעות והסעות',
  'estimate.template.accommodation': 'לינה',
  'estimate.template.dailyLiving': 'מחיה יומיומית',
  'estimate.template.other': 'אחר',
  'estimate.unit.item': 'פריט',
  'estimate.unit.service': 'שירות',
  'estimate.unit.day': 'יום',
  'estimate.unit.night': 'לילה',
  'estimate.unit.trip': 'נסיעה',
  'estimate.unit.hour': 'שעה',
  'estimate.unit.week': 'שבוע',
  'estimate.unit.person': 'אדם',
  'estimate.unit.package': 'חבילה',
  'estimate.expiry.24h': '24 שעות',
  'estimate.expiry.7d': '7 ימים',
  'estimate.expiry.30d': '30 ימים',
  'estimate.drift.unavailable': 'המקור אינו זמין עוד; השורה שומרת את הצילום שלה.',
  'estimate.drift.price': 'המחיר בקטלוג השתנה מאז שהשורה נלקחה.',
  'estimate.drift.revision': 'בקטלוג יש גרסה חדשה יותר של מקור זה.',
  'estimate.error.issuedAlready': 'הערכת העלות כבר הונפקה ואי אפשר לשנותה.',
  'estimate.error.sourceUnavailable': 'אחד המקורות אינו זמין עוד.',
  'estimate.error.limit': 'הערכת העלות חורגת ממגבלה: 20 מקטעים, 200 שורות, כמות 1–9999.',
  'estimate.error.issueInvalid': 'אי אפשר להנפיק את הערכת העלות במצבה הנוכחי.',
  'estimate.error.idempotency': 'הבקשה הזו כבר נשלחה עם תוכן אחר.',
  'estimate.error.forbidden': 'לחשבון שלך אין הרשאה לכך.',
  'estimate.error.notFound': 'הערכת העלות לא נמצאה.',
  'estimate.error.invalid': 'השרת דחה את הערכת העלות כפי שנשלחה.',
  'estimate.error.conflict': 'הערכת העלות השתנתה בשרת.',
  'estimate.error.failed': 'לא ניתן היה לשמור את הערכת העלות.',

  'estimate.list.title': 'הערכות עלות',
  'estimate.list.column.title': 'הערכת עלות',
  'estimate.list.column.locale': 'שפה',
  'estimate.list.column.validThrough': 'בתוקף עד',
  'estimate.list.column.total': 'סה"כ',
  'estimate.list.column.when': 'הונפקה / עודכנה',
  'estimate.list.column.actions': 'פעולות',
  'estimate.list.noNumber': 'עדיין אין מספר',
  'estimate.list.pendingDraft': 'טיוטה, גרסה {revision}',
  'estimate.list.openPendingDraft': 'פתיחת טיוטת גרסה {revision} של {name}',
  'estimate.list.issuedAt': 'הונפקה {time}',
  'estimate.list.updatedAt': 'עודכנה {time}',
  'estimate.list.openDraft': 'פתיחת הטיוטה {name}',
  'estimate.list.openIssued': 'פתיחת הערכת העלות {name}',
  'estimate.list.create': 'הערכת עלות חדשה',
  'estimate.list.empty': 'עדיין אין הערכות עלות',
  'estimate.list.emptyDetail': 'טרם נערכה הערכת עלות למטופל זה.',
  'estimate.list.emptyDetailWrite': 'צרו את הערכת העלות הראשונה כדי לתכנן את עלויות הטיפול.',
  'estimate.list.noMatches': 'אין הערכות עלות תואמות',
  'estimate.list.noMatchesDetail': 'הרפו את המסננים כדי לראות עוד הערכות עלות.',
  'estimate.list.loading': 'טוען הערכות עלות…',
  'estimate.list.loadFailed': 'לא ניתן היה לטעון את הערכות העלות.',
  'estimate.list.forbidden': 'הערכות עלות אינן זמינות לחשבון שלך',
  'estimate.list.forbiddenDetail': 'קריאת הערכות עלות טיפול דורשת את ההרשאה finance.estimates.read.',

  'estimate.create.title': 'הערכת עלות חדשה',
  'estimate.create.description': 'קודם הכותרת; השורות נבחרות בעורך.',
  'estimate.create.defaultTitle': 'הערכת עלות טיפול',
  'estimate.create.cancel': 'ביטול',
  'estimate.create.confirm': 'יצירה',
  'estimate.create.creating': 'יוצר…',
  'estimate.fields.documentLocale': 'שפת המסמך',
  'estimate.fields.title': 'כותרת',
  'estimate.fields.planningDate': 'תאריך תמחור',
  'estimate.fields.validThrough': 'בתוקף עד',
  'estimate.fields.plannedStart': 'התחלה מתוכננת',
  'estimate.fields.plannedEnd': 'סיום מתוכנן',
  'estimate.fields.case': 'תיק',
  'estimate.fields.noCase': 'ללא תיק',
  'estimate.fields.assumptions': 'הנחות',

  'estimate.validation.title': 'נדרשת כותרת.',
  'estimate.validation.planningDate': 'נדרש תאריך תמחור לבחירת תעריף חדש.',
  'estimate.validation.source': 'בחרו מחירון מתוארך וסניף לשירות זה.',
  'estimate.validation.validThrough': 'נדרש תאריך תוקף.',
  'estimate.validation.plannedRange': 'הסיום המתוכנן לא יכול להיות לפני ההתחלה המתוכננת.',
  'estimate.validation.customTitleBlank': 'מקטע מותאם אישית זקוק לשם.',
  'estimate.validation.customTitleDuplicate': 'שני מקטעים לא יכולים לשאת אותו שם.',
  'estimate.validation.templateDuplicate': 'כל תבנית ניתנת לשימוש פעם אחת.',
  'estimate.validation.sectionLimit': 'לכל היותר 20 מקטעים.',
  'estimate.validation.lineLimit': 'לכל היותר 200 שורות.',
  'estimate.validation.quantity': 'הכמות חייבת להיות בין {min} ל-{max}.',
  'estimate.validation.quantityShort': 'כמות {min}–{max}',
  'estimate.validation.amount': 'נדרש מחיר.',
  'estimate.validation.overrideReason': 'מחיר שנדרס זקוק לסיבה.',
  'estimate.validation.emptySection': 'במקטע "{name}" אין שורות.',
  'estimate.validation.emptySections': 'לפני ההנפקה כל מקטע צריך לפחות שורה אחת.',
  'estimate.validation.limits': 'מקטעים: {sections} מתוך 20 · שורות: {lines} מתוך 200',
  'estimate.validation.noLines': 'בחרו לפחות שורה אחת לפני ההפקה.',

  'estimate.section.untitled': 'מקטע ללא שם',
  'estimate.section.subtotal': 'סכום ביניים {amount}',

  'estimate.totals.label': 'סיכומים',
  'estimate.totals.clinic': 'שירותי המרפאה',
  'estimate.totals.external': 'הוצאות חיצוניות',
  'estimate.totals.grand': 'סה"כ כללי',
  'estimate.totals.serverNote': 'לפי השמירה האחרונה בשרת.',
  'estimate.totals.localNote': 'סכומים שהשתנו יאושרו בשמירת הטיוטה.',
  'estimate.totals.pending': 'ממתין לשמירה',
  'estimate.grid.label': 'שורות הערכת העלות',
  'estimate.grid.column.name': 'פריט',
  'estimate.grid.column.quantity': 'כמות',
  'estimate.grid.column.unit': 'יחידה',
  'estimate.grid.column.price': 'מחיר ליחידה',
  'estimate.grid.column.total': 'סה״כ',
  'estimate.grid.empty': 'עדיין אין שורות',
  'estimate.grid.emptyDetail': 'בחרו שירותים והוצאות חיצוניות מהלוח; כל פריט מתויק תחת קבוצת הקטלוג שלו.',

  'estimate.conflict.title': 'הערכת העלות השתנתה בשרת',
  'estimate.conflict.description': 'מישהו שמר את הערכת העלות הזו אחרי שפתחתם אותה.',
  'estimate.conflict.descriptionRevision': 'בשרת נמצאת גרסה {revision}; העריכות שלכם נעשו על גרסה ישנה יותר.',
  'estimate.conflict.keepEditing': 'המשך עריכה',
  'estimate.conflict.reload': 'ביטול השינויים שלי וטעינה מחדש',
  'estimate.conflict.reapply': 'החלת השינויים שלי על הגרסה האחרונה',
  'estimate.conflict.reapplying': 'מחיל…',
  'estimate.conflict.loading': 'משווה מול השרת…',
  'estimate.conflict.loadFailed': 'לא ניתן היה לטעון את גרסת השרת.',
  'estimate.conflict.summaryLabel': 'מה שונה',
  'estimate.conflict.headerChanged': 'שדות כותרת שהשתנו: {count}',
  'estimate.conflict.sectionsOnlyLocal': 'מקטעים רק בטיוטה שלי: {count}',
  'estimate.conflict.sectionsOnlyServer': 'מקטעים רק בשרת: {count}',
  'estimate.conflict.linesOnlyLocal': 'שורות רק בטיוטה שלי: {count}',
  'estimate.conflict.linesOnlyServer': 'שורות רק בשרת: {count}',
  'estimate.conflict.linesChanged': 'שורות שהשתנו בשני הצדדים: {count}',
  'estimate.conflict.noDifferences': 'אין הבדלים בתוכן.',
  'estimate.conflict.reloadTitle': 'לבטל את השינויים שלכם?',
  'estimate.conflict.reloadDescription': 'העריכות שלא נשמרו יוחלפו בגרסת השרת.',
  'estimate.conflict.reloadConfirm': 'ביטול וטעינה מחדש',

  'estimate.issue.title': 'הנפקת הערכת העלות',
  'estimate.issue.description': 'ההנפקה מקפיאה את התוכן, מקצה מספר ומפיקה PDF.',
  'estimate.issue.patient': 'מטופל',
  'estimate.issue.missing': 'חסר',
  'estimate.issue.structure': 'מבנה',
  'estimate.issue.structureValue': 'מקטעים: {sections} · שורות: {lines}',
  'estimate.issue.blocked': 'תקנו את אלה לפני ההנפקה',
  'estimate.issue.cancel': 'ביטול',
  'estimate.issue.confirm': 'הנפקה והפקת PDF',
  'estimate.issue.issuing': 'מנפיק…',
  'estimate.disclaimer': 'זוהי הערכת עלות ולא חשבונית. הוצאות חיצוניות הן משוערות ומשולמות לצדדים שלישיים.',

  'estimate.pdf.title': 'מסמכי PDF',
  'estimate.pdf.rendering': 'מפיק PDF…',
  'estimate.pdf.retry': 'ניסיון PDF נוסף',
  'estimate.pdf.loadingArtifacts': 'טוען מסמכים…',
  'estimate.pdf.artifactsFailed': 'לא ניתן היה לטעון את המסמכים.',
  'estimate.pdf.none': 'עדיין לא הופק PDF.',
  'estimate.pdf.renderer': 'מנוע הפקה {version} · {hash}',
  'estimate.pdf.download': 'הורדה',
  'estimate.pdf.view': 'הצגה',
  'estimate.pdf.viewNamed': 'הצגת ה-PDF: {language}',
  'estimate.pdf.downloadFailed': 'לא ניתן היה להוריד את ה-PDF.',
  'estimate.pdf.generate': 'הפקת PDF',
  'estimate.pdf.forbidden': 'לחשבון שלך אין הרשאה להפיק PDF זה.',
  'estimate.pdf.unavailable': 'לשפת המסמך לא מקושר טופס הדפסה.',
  'estimate.pdf.conflict': 'ה-PDF כבר הופק עבור בקשה זו.',
  'estimate.pdf.failed': 'לא ניתן היה להפיק את ה-PDF.',

  'estimate.send.open': 'שליחה למטופל',
  'estimate.send.needsPdf': 'קודם הפיקו את ה-PDF.',
  'estimate.send.title': 'שליחה למטופל',
  'estimate.send.description': 'המטופל מקבל קישור ל-PDF; תוקף הקישור מוגבל.',
  'estimate.send.artifact': 'מסמך',
  'estimate.send.artifactOption': '{locale} · {time}',
  'estimate.send.expiry': 'הקישור פג בעוד',
  'estimate.send.preview': 'תצוגה מקדימה של ההודעה',
  'estimate.send.previewBody':
    'מטופל יקר, הערכת עלות הטיפול שלך "{title}" {number} מוכנה. הערכת העלות בתוקף עד {validThrough}. הקישור למסמך פג בעוד {expiry}.',
  'estimate.send.cancel': 'ביטול',
  'estimate.send.confirm': 'שליחה',
  'estimate.send.sending': 'שולח…',
  'estimate.send.done': 'סגירה',
  'estimate.send.result': 'משלוח: {state}',

  'estimate.delivery.title': 'משלוחים',
  'estimate.delivery.loading': 'טוען משלוחים…',
  'estimate.delivery.loadFailed': 'לא ניתן היה לטעון את המשלוחים.',
  'estimate.delivery.none': 'טרם נשלח.',
  'estimate.delivery.column.channel': 'ערוץ',
  'estimate.delivery.column.artifact': 'מסמך',
  'estimate.delivery.column.state': 'מצב',
  'estimate.delivery.column.times': 'ציר זמן',
  'estimate.delivery.column.link': 'קישור',
  'estimate.delivery.column.actions': 'פעולות',
  'estimate.delivery.createdAt': 'נשלח {time}',
  'estimate.delivery.expiresAt': 'פג {time}',
  'estimate.delivery.revokedAt': 'בוטל {time}',
  'estimate.delivery.linkActive': 'הקישור פעיל',
  'estimate.delivery.linkExpired': 'הקישור פג',
  'estimate.delivery.linkRevoked': 'הקישור בוטל',
  'estimate.delivery.downloads': 'הורדות: {count}',
  'estimate.delivery.firstAccess': 'נפתח לראשונה {time}',
  'estimate.delivery.lastAccess': 'נפתח לאחרונה {time}',
  'estimate.delivery.revoke': 'ביטול הקישור',
  'estimate.delivery.revokeTitle': 'לבטל קישור זה?',
  'estimate.delivery.revokeDescription':
    'המטופל לא יוכל עוד לפתוח דרכו את המסמך. הדרך היחידה לתת קישור שוב היא שליחה חדשה.',
  'estimate.delivery.revokeCancel': 'להשאיר את הקישור',
  'estimate.delivery.revokeConfirm': 'ביטול הקישור',
  'estimate.delivery.revoking': 'מבטל…',

  'estimate.revision.open': 'עריכה',
  'estimate.revision.title': 'לערוך הערכת עלות זו?',
  'estimate.revision.description':
    'עותק לעריכה של {number} (גרסה {revision}) ייווצר כטיוטה חדשה; מסמך זה נשאר כפי שהופק.',
  'estimate.revision.cancel': 'ביטול',
  'estimate.revision.confirm': 'יצירת העותק לעריכה',
  'estimate.revision.creating': 'יוצר…',

  'estimate.delete.open': 'מחיקת הטיוטה',
  'estimate.delete.title': 'למחוק את הטיוטה?',
  'estimate.delete.description':
    'הטיוטה {name} וכל מה שנבחר לתוכה יימחקו לצמיתות. מסמכים שכבר הונפקו אינם מושפעים.',
  'estimate.delete.cancel': 'להשאיר את הטיוטה',
  'estimate.delete.confirm': 'מחיקת הטיוטה',
  'estimate.delete.deleting': 'מוחק…',

  'estimate.revisions.column.status': 'סטטוס',
  'estimate.revisions.column.number': 'מספר',
  'estimate.revisions.column.when': 'הונפקה / עודכנה',
  'estimate.revisions.column.total': 'סה"כ',
  'estimate.revisions.open': 'פתיחת גרסה {revision}',
  'estimate.revisions.reading': 'גרסה {revision}, פתוחה כעת',
  'estimate.revisions.loadFailed': 'לא ניתן היה לטעון את היסטוריית הגרסאות.',

  'estimate.detail.loading': 'טוען את הערכת העלות…',
  'estimate.detail.notFound': 'הערכת עלות זו אינה קיימת למטופל זה.',
  'estimate.detail.forbidden': 'לחשבון שלך אין הרשאה לקרוא הערכת עלות זו.',
  'estimate.detail.loadFailed': 'לא ניתן היה לטעון את הערכת העלות.',
  'estimate.detail.readOnlyDraft': 'טיוטה זו פתוחה לחשבון שלך לקריאה בלבד.',
  'estimate.detail.planned': 'תקופה מתוכננת',
  'estimate.detail.issuedAt': 'הונפקה',
  'estimate.detail.updatedAt': 'עודכנה',
  'estimate.detail.factsLabel': 'פרטי המסמך',
  'estimate.detail.overrideNote': 'המחיר נדרס: {reason}',

  'estimate.builder.untitled': 'הערכת עלות ללא שם',
  'estimate.builder.backToList': 'כל הערכות העלות',
  'estimate.builder.updatedAt': 'עודכנה {time}',
  'estimate.builder.actionsLabel': 'פעולות על הערכת העלות',
  'estimate.builder.saving': 'שומר…',
  'estimate.builder.unsaved': 'יש שינויים שלא נשמרו',
  'estimate.builder.saved': 'נשמר',
  'estimate.builder.detailsLabel': 'פרטי הערכת העלות',
  'estimate.builder.pick': 'הוספת פריטים',
  'estimate.builder.save': 'שמירה',
  'estimate.builder.issue': 'הנפקה והפקת PDF',
  'estimate.builder.sectionLimit': 'מקטעים לכל היותר: {limit}',
  'estimate.builder.lineLimit': 'שורות לכל היותר: {limit}',
  'estimate.builder.sectionLimitPick': '{name} דורש מקטע חדש, {section}; בהערכת העלות כבר יש {limit} מקטעים.',
  'estimate.builder.alreadyPresent': '{name} כבר נמצא במקטע {section}.',
  'estimate.builder.added': '{name} נוסף למקטע {section}.',
  'estimate.builder.refreshUnavailable': '{name} אינו עוד בקטלוג; השורה שומרת את הצילום שלה.',
  'estimate.builder.refreshed': '{name} רוענן מהקטלוג.',

  'estimate.line.priceLocked': 'מחיר המרפאה, מהמחירון',
  'estimate.line.overrideReason': 'סיבה לדריסת {amount}',
  'estimate.line.note': 'הערה',
  'estimate.line.noteLabel': 'הערה עבור {name}',
  'estimate.line.refresh': 'רענון {name} מהקטלוג',
  'estimate.line.refreshHint': 'לקחת את המחיר והשם הנוכחיים',
  'estimate.line.remove': 'הסרת {name} מהמקטע {section}',
  'estimate.line.quantityLabel': 'כמות של {name} ({unit})',
  'estimate.line.decrease': 'הפחתת {name}',
  'estimate.line.increase': 'הגדלת {name}',
  'estimate.line.unitPrice': 'מחיר ליחידה של {name}',

  'estimate.remove.lineTitle': 'להסיר שורה זו?',
  'estimate.remove.lineDescription': '"{name}" נושא הערה או מחיר שנדרס; ההסרה תמחק אותם.',
  'estimate.remove.cancel': 'להשאיר',
  'estimate.remove.confirm': 'הסרה',
  'estimate.refresh.title': 'לרענן את {name}?',
  'estimate.refresh.description': 'הקטלוג השתנה מאז שהשורה נלקחה.',
  'estimate.refresh.amount': 'מחיר: {from} ← {to}',
  'estimate.refresh.display': 'שם: {from} ← {to}',
  'estimate.refresh.cancel': 'להשאיר כמו שזה',
  'estimate.refresh.confirm': 'רענון',

  'estimate.picker.title': 'שירותים והוצאות חיצוניות',
  'estimate.picker.priceList': 'מחירון',
  'estimate.picker.choosePriceList': 'בחרו מחירון',
  'estimate.picker.branch': 'סניף',
  'estimate.picker.chooseBranch': 'בחרו סניף',
  'estimate.picker.selectionRequired': 'בחרו מחירון וסניף.',
  'estimate.picker.selectionLoading': 'טוען מחירונים וסניפים.',
  'estimate.picker.selectionFailed': 'לא ניתן לטעון מחירונים או סניפים.',
  'estimate.picker.datedForbidden': 'אין לך גישה למחירונים.',
  'estimate.picker.resolving': 'בודק את המחיר לתאריך התכנון.',
  'estimate.picker.resolveFailed': 'לא ניתן לקבוע מחיר לשירות, לסניף ולתאריך התכנון שנבחרו. לא נוסף פריט.',
  'estimate.picker.currencyMismatch': 'הגדרת המטבע של מקור זה שונה מזו של האומדן.',
  'estimate.picker.baseTariff': 'תעריף בסיס: {amount}',
  'estimate.picker.catalogueTab': 'קטלוג',
  'estimate.picker.searchPlaceholder': 'חיפוש לפי קוד או שם',
  'estimate.picker.hint': 'פריט שנבחר מתויק תחת קבוצת הקטלוג שלו.',
  'estimate.picker.shortlistMissing': '{name} אינו במחירון.',
  'estimate.picker.clinicHint': 'שירותי המרפאה מהמחירון',
  'estimate.picker.externalHint': 'הוצאות חיצוניות מהקטלוג',
  'estimate.picker.noMatches': 'אין התאמות.',
  'estimate.picker.clinicLeafMeta': '{unit}',
  'estimate.picker.externalLeafMeta': '{path} · {unit}',
  'estimate.picker.externalLoading': 'טוען את קטלוג ההוצאות החיצוניות…',
  'estimate.picker.externalFailed': 'לא ניתן היה לטעון את קטלוג ההוצאות החיצוניות.',
  'estimate.picker.externalEmpty': 'קטלוג ההוצאות החיצוניות ריק.',
  'estimate.picker.lineLimit': 'בהערכת העלות כבר יש 200 שורות.',
  'estimate.unsavedIntent': 'הערכת עלות עם שינויים שלא נשמרו',

  'externalCosts.title': 'הוצאות חיצוניות',
  'externalCosts.subtitle': 'הוצאות צד שלישי שהערכת עלות יכולה לצטט לצד שירותי המרפאה',
  'externalCosts.forbidden': 'קטלוג ההוצאות החיצוניות אינו זמין לחשבון שלך.',
  'externalCosts.loading': 'טוען את הקטלוג…',
  'externalCosts.loadFailed': 'לא ניתן היה לטעון את הקטלוג.',
  'externalCosts.tableLabel': 'קטלוג הוצאות חיצוניות',
  'externalCosts.column.name': 'שם',
  'externalCosts.column.group': 'קבוצה',
  'externalCosts.column.unit': 'יחידה',
  'externalCosts.column.amount': 'מחיר ברירת מחדל',
  'externalCosts.column.status': 'מצב',
  'externalCosts.actions': 'פעולות',
  'externalCosts.editNamed': 'עריכת {name}',
  'externalCosts.openNamed': 'פתיחת {name}',
  'externalCosts.openGroupNamed': 'פתיחת הקבוצה {name}',
  'externalCosts.moveSelected': 'העברת {count} שנבחרו',
  'externalCosts.moveSelectedTitle': 'העברה לקבוצה אחרת',
  'externalCosts.moveSelectedDescription':
    '{count} רשומות בקטלוג יועברו לסוף הקבוצה שתבחרו, לפי הסדר שבו הן עומדות בעץ.',
  'externalCosts.moveSelectedTarget': 'יעד',
  'externalCosts.moveSelectedHint': 'מוצגות רק קבוצות שיכולות להכיל את כל הבחירה.',
  'externalCosts.moveSelectedConfirm': 'העברת {count} רשומות',
  'externalCosts.moveSelectedCancel': 'להשאיר את הבחירה',
  'externalCosts.movedCount': '{count} רשומות הועברו.',
  'externalCosts.movedBefore': 'לפני כן הועברו {count} רשומות.',
  'externalCosts.empty': 'אין הוצאות חיצוניות',
  'externalCosts.emptyDetail': 'עדיין לא נוסף דבר.',
  'externalCosts.emptyDetailManage': 'הוסיפו הוצאה — קבוצה מאחדת כמה מהן.',
  'externalCosts.noMatches': 'אין התאמות.',
  'externalCosts.noMatchesDetail': 'נקו מסנן כדי לראות עוד מהקטלוג.',
  'externalCosts.pathStep': '{parent} / {child}',
  'externalCosts.archived': 'בארכיון',
  'externalCosts.archivedByParent': 'תחת קבוצה בארכיון',
  'externalCosts.status.active': 'פעיל',
  'externalCosts.saved': 'נשמר.',
  'externalCosts.unsavedIntent': 'צומת הוצאה חיצונית עם שינויים שלא נשמרו',
  'externalCosts.kind.group': 'קבוצה',
  'externalCosts.kind.item': 'פריט',
  'externalCosts.groups.open': 'קבוצות',
  'externalCosts.groups.title': 'קבוצות',
  'externalCosts.tree.search': 'חיפוש בקטלוג',
  'externalCosts.tree.root': 'הקטלוג כולו',
  'externalCosts.tree.showAll': 'הכול',
  'externalCosts.tree.showGroups': 'קבוצות בלבד',
  'externalCosts.tree.showItems': 'פריטים בלבד',
  'externalCosts.tree.empty': 'אין עדיין קבוצות או פריטים.',
  'externalCosts.tree.levelEmpty': 'עדיין לא תויק כאן דבר.',
  'externalCosts.tree.levelItemsOnly': 'כאן מתויקים פריטים בלבד, והתצוגה מציגה קבוצות.',
  'externalCosts.tree.unfold': 'הצגת הכול',
  'externalCosts.tree.noMatches': 'שום דבר בקטלוג אינו תואם.',
  'externalCosts.tree.scopeChip': 'בתוך {name}',
  'externalCosts.tree.scopeClear': 'הצגת הקטלוג כולו',
  'externalCosts.tree.menu': 'פעולות עבור {name}',
  'externalCosts.tree.open': 'פתיחה',
  'externalCosts.tree.rename': 'שינוי שם',
  'externalCosts.tree.addGroup': 'הוספת קבוצה כאן',
  'externalCosts.tree.addItem': 'הוספת פריט כאן',
  'externalCosts.tree.moveEarlier': 'העברה למעלה',
  'externalCosts.tree.moveLater': 'העברה למטה',
  'externalCosts.tree.moveToTop': 'העברה לרמה העליונה',
  'externalCosts.tree.stale': 'הקטלוג השתנה בינתיים ונטען מחדש. נסו שוב.',
  'externalCosts.create.under': 'תחת {name}',
  'externalCosts.create.kind': 'מה להוסיף',
  'externalCosts.create.groupHint': 'כותרת שמכילה פריטים',
  'externalCosts.create.itemHint': 'הוצאה מתומחרת עם יחידה',
  'externalCosts.create.submit': 'יצירה',
  'externalCosts.create.creating': 'יוצר…',
  'externalCosts.detail.archive': 'העברה לארכיון',
  'externalCosts.detail.restore': 'שחזור',
  'externalCosts.detail.noAmount': 'אין מחיר ברירת מחדל',
  'externalCosts.editor.newGroup': 'קבוצה חדשה',
  'externalCosts.editor.newItem': 'פריט חדש',
  'externalCosts.editor.name': 'שם',
  'externalCosts.editor.description': 'תיאור',
  'externalCosts.editor.unit': 'יחידה',
  'externalCosts.editor.unitNone': 'ללא יחידה',
  'externalCosts.editor.amount': 'מחיר ברירת מחדל, {currency}',
  'externalCosts.editor.amountUnknown': 'מחיר ברירת מחדל',
  'externalCosts.error.currencyUnavailable': 'מטבע הפרופיל הפיננסי אינו זמין. לא ניתן לשמור רשומות בקטלוג.',
  'externalCosts.error.currencyMismatch': 'הגדרת המטבע של מחיר זה שונה מהפרופיל הפיננסי הנוכחי. יש ליצור פריט חדש כדי להשתמש במטבע הנוכחי.',
  'externalCosts.editor.group': 'קבוצה',
  'externalCosts.editor.groupHint': 'הקטלוג מחזיק רמה אחת של קבוצות.',
  'externalCosts.editor.rootParent': 'רמה עליונה',
  'externalCosts.editor.save': 'שמירה',
  'externalCosts.editor.saving': 'שומר…',
  'externalCosts.editor.gone': 'צומת זה אינו עוד בקטלוג.',
  'externalCosts.editor.conflict': 'הקטלוג השתנה מאז שפתחתם טופס זה. טענו אותו מחדש — הרשומות שלכם נשארות — ושמרו שוב.',
  'externalCosts.editor.reload': 'טעינת הקטלוג מחדש',
  'externalCosts.editor.reloading': 'טוען מחדש…',
  'externalCosts.editor.discard': 'ביטול השינויים שלי',
  'externalCosts.validation.name': 'נדרש שם.',
  'externalCosts.validation.unit': 'לפריט נדרשת יחידה.',
  'externalCosts.validation.amount': 'הזינו מחיר שאינו שלילי, בדיוק העשרוני של המטבע.',
  'externalCosts.error.codeConflict': 'לא ניתן היה לקבוע קוד פנימי לרשומה. נסו שוב.',
  'externalCosts.error.cycle': 'אי אפשר להעביר קבוצה לתוך עצמה.',
  'externalCosts.error.parentUnavailable': 'האב שנבחר נמחק או בארכיון.',
  'externalCosts.error.depthExceeded': 'העץ מאפשר עד שש רמות.',
  'externalCosts.error.forbidden': 'לחשבון שלך אין הרשאה לשנות את הקטלוג.',
  'externalCosts.error.invalid': 'השרת דחה את הצומת כפי שנשלח.',
  'externalCosts.error.conflict': 'הקטלוג דחה את השינוי.',
  'externalCosts.error.failed': 'לא ניתן היה לשנות את הקטלוג.',
  'externalCosts.archive.title': 'להעביר את {name} לארכיון?',
  'externalCosts.archive.groupDescription':
    'הקבוצה לא תוצע עוד לשורות חדשות של הערכות עלות, וכך גם הצמתים שבתוכה: {count}. שורות קיימות שומרות את הצילומים שלהן.',
  'externalCosts.archive.itemDescription':
    'הפריט לא יוצע עוד לשורות חדשות של הערכות עלות. שורות קיימות שומרות את הצילומים שלהן.',
  'externalCosts.archive.cancel': 'להשאיר',
  'externalCosts.archive.confirm': 'העברה לארכיון',
  'externalCosts.archive.archiving': 'מעביר לארכיון…',
}
